import { Spin } from 'antd'

export const Preloader = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      left: 0,
      top: 0,
      zIndex: 1,
      width: '100%',
      height: '100%',
      color: '#000',
      fontSize: '24px',
      flexDirection: 'column'
    }}
  >
    <Spin size='large' />
    <p>Loading</p>
  </div>
)
